// returns a binder for input element based on its type
export default function input(type) {
  var on;
  switch (type) {
    case 'checkbox':
      return {
        on: 'click keyup',
        getValue: function getValue() {
          return this.checked;
        },
        setValue: function setValue(value) {
          this.checked = value;
        }
      };
    case 'radio':
      return {
        on: 'click keyup',
        // an unchecked radio keeps the value of its checked sibling
        getValue: function getValue(_temp) {
          var _ref = _temp === void 0 ? {} : _temp,
            previousValue = _ref.previousValue;
          return this.checked ? this.value : previousValue;
        },
        setValue: function setValue(value) {
          // a number checks the radio with the same text, as the select binder does
          this.checked = value !== undefined && value !== null && this.value === String(value);
        }
      };
    case 'submit':
    case 'button':
    case 'image':
    case 'reset':
      return {};
    case 'hidden':
      on = null;
      break;
    case 'file':
      // a browser refuses any value of a file input but an empty one, so the object can only clear it
      return {
        on: 'change',
        getValue: function getValue() {
          return this.value;
        },
        setValue: function setValue(value) {
          if (value === null || value === undefined || value === '') this.value = '';
        }
      };
    /*
            case 'text':
            case 'password':
            case 'date':
            case 'datetime':
            case 'datetime-local':
            case 'month':
            case 'time':
            case 'week':
            case 'range':
            case 'color':
            case 'search':
            case 'email':
            case 'tel':
            case 'url':
            case 'file':
            case 'number': */
    default:
      // other future (HTML6+) inputs
      on = 'input';
  }
  return {
    on: on,
    getValue: function getValue() {
      return this.value;
    },
    setValue: function setValue(value) {
      var text = value === null || value === undefined ? '' : String(value);
      // the same text isn't written again, so the caret stays
      if (this.value !== text) {
        this.value = text;
      }
    }
  };
}